module.exports = {

  /*
  Extra vendor files to copy

  Here, you can add paths to any files within Node modules you need to be copied to the output dist/js/vendor/ directory - which allows you to use JavaScript libraries (like sliders etc.) installed via NPM.

  These are also copied along with anything you put in the vendor/ directory here.

  For example, if you were to enter the following:
  './node_modules/slick-carousel/slick/slick.*js'
  the slick.js and slick.min.js files would be copied from the slick-carousel package (these are already included in the base theme).

  Strings entered here use patterns from the Glob library, which you may be familiar with from Gulp.js: https://github.com/isaacs/node-glob#glob-primer
  */
  extraVendor: [

  ],

  /*
  API keys for various services used in the blocks
  */
  apiKeys: {
    // Google Maps JavaScript API
    googleMaps: 'AIzaSyAFxW0teeINbzH6zib51KGE_w5oBItH0y8'
  },

  /*
  The spacers (padding) which are used, should match the ones set in the Sass in config/layout.scss
  */
  spacers: {
    0: '0',
    1: '10px',
    2: '15px',
    3: '20px',
    4: '30px',
    5: '40px',
    6: '50px',
    7: '75px',
    8: '100px'
  },

  /*
  JavaScript block settings
  */
  blocks: {

    // Section block
    section: {

      // The top and bottom padding options which should be available.
      // spacerKey corresponds to the spacers array in this file, label displays in the WP admin
      paddingOptions: [
        { spacerKey: 0, label: 'None' },
        { spacerKey: 4, label: 'Small' },
        { spacerKey: 7, label: 'Medium' },
        { spacerKey: 8, label: 'Large' }
      ],

      // The key of the default padding option
      defaultPadding: 8

    },

    // Map (Google Map embed) block
    map: {

      // The image used for the marker
      markerImage: {
        url: '/wp-content/themes/hca-cite-theme/resources/assets/dist/img/map-marker.svg',

        // Dimensions the image should show at
        size: {
          width: 64,
          height: 62
        },

        // The anchor point of the marker, which should be where the marker 'points' to
        anchor: {
          x: 32,
          y: 31
        }
      },

      // Options passed to the Google Maps object.
      // @see {@link https://developers.google.com/maps/documentation/javascript/reference/map#MapOptions}
      options: {
        // styles can be set to an array of map styles such as ones provided by services like Snazzy Maps
        /* styles: [] */
      }

    }

  }

}